import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Atomic from "../../../../AComponent/Atomic";
import { isUserDefined } from "../Helpers/helper";

const { Input, Button, Checkboxes } = Atomic;

export const SelectGroup = ({ onGroupChecked, onGroupUnChecked, id }) => {
  const [checked, setChecked] = useState(false);
  const onChangeHandler = (value) => {
    setChecked(value);
    if (value) {
      console.log(id);
      onGroupChecked(id);
    } else {
      onGroupUnChecked(id);
    }
  };
  return <Checkboxes onChange={onChangeHandler} value={checked} />;
};

const AddGroup = (props) => {
  const { record, type, rule, targetRules, closeForm, weightData } = props;
  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");
  const [description, setDescription] = useState("");
  const [uom, setUom] = useState("");
  // const [libItem, setLibItem] = useState(-1);

  const [weights, setWeights] = useState({
    WeightRule: weightData?.WeightRule,
    Weight: weightData?.Weight,
    MinimumWeight: weightData?.MinimumWeight,
    MaximumWeight: weightData?.MaximumWeight,
  });

  const onChangeHandler = (key, value) =>
    setWeights((prevState) => ({ ...prevState, [key]: value }));

  useEffect(() => {
    if (record) {
      setName(record.name);
      setShortName(record.shortName);
      setDescription(record.description);
      setUom(record.uom);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const TargetDataTypes = [...(targetRules?.TargetDataTypes || [])];

  const formType = type;
  const nameType =
    formType === "g2" ? "Group 2" : formType === "p" ? "Parameter" : "Group 1";
  const ruleType = rule;

  const nameChangeHandler = (value) => setName(value);
  const shortNameChangeHandler = (value) => setShortName(value);
  const descriptionChangeHandler = (value) => setDescription(value);
  const uomChangeHandler = (value) => setUom(value);
  const formSubmitHandler = () => {
    const updatedData = {
      name,
      shortName,
      description,
    };

    console.log(updatedData);

    closeForm();
  };

  console.log(ruleType, "pms");

  console.log(TargetDataTypes, "ADD GROUP");

  return (
    <Box
      sx={{
        height: "50vh",
        width: "40vw",
        padding: "0.5em 1em",
      }}
      className="scroll"
    >
      <Box sx={{ width: "100%" }}>
        {/* {isLibrary(ruleType) && (
          <Box sx={{ width: "100%" }}>
            <Typography variant="body1" sx={{ margin: "1em 0" }}>
              Add from Library
            </Typography>
            <Dropdown
              menuItems={libraryItems}
              label={"Type"}
              onChange={libraryItemChangeHandler}
              value={libItem}
            />
            <EwTable
              heading={getTableHeading(type)}
              rows={[
                ...libraryItems.map((item) => [
                  {
                    Component: SelectGroup,
                    props: { onGroupChecked, onGroupUnChecked, id: item.value },
                  },
                  item.label,
                ]),
              ]}
            />
          </Box>
        )} */}
        {isUserDefined(ruleType) && (
          <Box sx={{ width: "100%" }}>
            <Typography variant="h3" sx={{ margin: "1em 0" }}>
              {record ? "Edit" : "Create"} {record ? "" : "new"} {nameType}
            </Typography>
            <Box sx={{ flex: 1, marginRight: "0.5em" }}>
              <Input
                type={"text"}
                label={`${nameType} Name`}
                onChange={nameChangeHandler}
                value={name}
                styles={{ width: "100%", margin: "1em 0" }}
                rows={5}
              />
            </Box>
            <Box sx={{ flex: 1, marginRight: "0.5em" }}>
              <Input
                type={"text"}
                label={`${nameType} Short Name`}
                onChange={shortNameChangeHandler}
                value={shortName}
                styles={{ width: "100%", margin: "1em 0" }}
              />
            </Box>
            <Input
              type={"text"}
              label={`${nameType} Description`}
              onChange={descriptionChangeHandler}
              value={description}
              styles={{ width: "100%", margin: "1em 0" }}
              rows={5}
            />
            {formType === "p" && (
              <Input
                type={"text"}
                label={`${nameType} UOM`}
                onChange={uomChangeHandler}
                value={uom}
                styles={{ width: "100%", margin: "1em 0" }}
              />
            )}
          </Box>
        )}
        {/* <Box marginTop={"2em"}>
          <Typography variant="h3">Targets Settings</Typography>
          <Divider sx={{ margin: "1em auto" }} />
          {isDisabled(targetState.TargetsEnabled) ? (
            <div className="Flex">
              <Typography variant="body1">
                You don't have permission to configure target settings
              </Typography>
            </div>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "3em" }}>
              <Box>
                <Typography variant="h4">Target Type</Typography>
                <Typography variant="overline">
                  {targetState.TargetType === "FV"
                    ? "Fixed Value"
                    : "Incompatiable target type found"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h4" sx={{ mb: "1em" }}>
                  Target Data Type
                </Typography>
                {TargetDataTypes.length === 0 ? (
                  <Typography variant="overline">
                    No Target Data Types enabled
                  </Typography>
                ) : (
                  <Dropdown
                    label={"Target Data Types"}
                    menuItems={[
                      ...TargetDataTypes.map((dt) => {
                        console.log(dt, "ADD GROUP DATA TYPE", dataTypes[dt]);
                        return dataTypes[dt];
                      }),
                    ]}
                    onChange={(value) => {
                      setTargetState((prevState) => ({
                        ...prevState,
                        TargetDataType: value,
                        AchievementDataType: value,
                      }));
                    }}
                  />
                )}
              </Box>
              <Box>
                <Typography variant="h4">Achievement Data Type</Typography>
                <Typography variant="overline">
                  {targetState.AchievementDataType
                    ? dataTypes[targetState.AchievementDataType].label
                    : "Select Target Data Type"}
                </Typography>
              </Box>
            </Box>
          )}
        </Box> */}
        {weightData && (
          <Box marginTop={"2em"}>
            <Typography variant="h3">Configure Weights</Typography>
            <Divider sx={{ margin: "1em auto" }} />
            {weights.WeightRule === "M" && (
              <Box width={"100%"}>
                <Input
                  label={"Weight"}
                  value={weights.Weight}
                  onChange={(value) => {
                    onChangeHandler("Weight", value);
                    onChangeHandler("MinimumWeight", value);
                    onChangeHandler("MaximumWeight", value);
                  }}
                  styles={{ width: "100%", margin: "0.5em 0" }}
                />
              </Box>
            )}
            {weights.WeightRule === "E" && (
              <Box display={"flex"} alignItems={"center"} gap={"2em"}>
                <Box flex={"1"}>
                  <Input
                    label={"Weight"}
                    value={weights.Weight}
                    onChange={(value) => {
                      onChangeHandler("Weight", value);
                    }}
                  />
                </Box>
                <Box width={"100%"} flex={2}>
                  <Box width={"100%"}>
                    <Box flex={"1"}>
                      <Input
                        label={"Minimum Weight"}
                        value={weights.MinimumWeight || "0"}
                        onChange={(value) => {
                          onChangeHandler("MinimumWeight", value);
                        }}
                      />
                    </Box>
                    <Box flex={"1"}>
                      <Input
                        label={"Maximum Weight"}
                        value={weights.MaximumWeight || "100"}
                        onChange={(value) => {
                          onChangeHandler("MaximumWeight", value);
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {weights.WeightRule === "U" && (
              <Box display={"flex"} justifyContent={"center"}>
                <Box width={"100%"} flex={2}>
                  <Box width={"100%"}>
                    <Box flex={"1"}>
                      <Input
                        label={"Minimum Weight"}
                        value={weights.MinimumWeight || "0"}
                        onChange={(value) => {
                          onChangeHandler("MinimumWeight", value);
                        }}
                      />
                    </Box>
                    <Box flex={"1"}>
                      <Input
                        label={"Maximum Weight"}
                        value={weights.MaximumWeight || "100"}
                        onChange={(value) => {
                          onChangeHandler("MaximumWeight", value);
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {weights.WeightRule === "D" && (
              <div className="Flex">
                <Typography variant="overline">Weights are disabled</Typography>
              </div>
            )}
          </Box>
        )}
        <Button
          onClick={formSubmitHandler}
          title={"Submit"}
          variant={"contained"}
          style={{ marginTop: "2em", float: "right" }}
        />
      </Box>
    </Box>
  );
};

export default AddGroup;
